import * as Sentry from '@sentry/react';

import { Amplify } from 'aws-amplify';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App.tsx';
import { initMixpanel } from './common/tracking.ts';
import './index.css';
import store from './store/store';

initMixpanel();

Sentry.init({
  dsn: 'https://bba65d56e934d65a8b321ec261219ff9@o4508620432801792.ingest.de.sentry.io/4508681298903120',
  enabled: import.meta.env.MODE === 'production',
  integrations: [Sentry.replayIntegration()],
  release: __APP_VERSION__,
  environment: import.meta.env.VITE_ENV || 'local',
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// Function to fetch AWS configuration from the backend
const fetchAwsConfig = async () => {
  const response = await axios.get('/api/v1/auth/cognito');
  return response.data;
};

const Root = () => {
  const [configLoaded, setConfigLoaded] = useState(false);

  useEffect(() => {
    const loadConfig = async () => {
      try {
        const awsConfig = await fetchAwsConfig();
        Amplify.configure(awsConfig);
        setConfigLoaded(true);
      } catch (error) {
        console.error('Failed to load AWS config:', error);
      }
    };

    void loadConfig();
  }, []);

  if (!configLoaded) {
    return <div>Loading...</div>;
  }

  return (
    <Provider store={store}>
      <App />
    </Provider>
  );
};

const rootElement = document.getElementById('root');
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <Root />
    </React.StrictMode>,
  );
} else {
  console.error('Root element not found');
}
